function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.33332 1.33203C0.965133 1.33203 0.666656 1.63051 0.666656 1.9987V11.9987C0.666656 12.3669 0.965133 12.6654 1.33332 12.6654H5.99999C6.35361 12.6654 6.69275 12.8058 6.9428 13.0559C7.19285 13.3059 7.33332 13.6451 7.33332 13.9987C7.33332 14.3669 7.6318 14.6654 7.99999 14.6654C8.36818 14.6654 8.66666 14.3669 8.66666 13.9987C8.66666 13.6451 8.80713 13.3059 9.05718 13.0559C9.30723 12.8058 9.64637 12.6654 9.99999 12.6654H14.6667C15.0348 12.6654 15.3333 12.3669 15.3333 11.9987V1.9987C15.3333 1.63051 15.0348 1.33203 14.6667 1.33203H10.6667C9.7826 1.33203 8.93476 1.68322 8.30963 2.30834C8.19745 2.42053 8.09409 2.53989 7.99999 2.66534C7.9059 2.53989 7.80253 2.42053 7.69035 2.30834C7.06522 1.68322 6.21738 1.33203 5.33332 1.33203H1.33332ZM8.66666 11.6893C9.06859 11.4572 9.52784 11.332 9.99999 11.332H14V2.66536H10.6667C10.1362 2.66536 9.62752 2.87608 9.25244 3.25115C8.87737 3.62622 8.66666 4.13493 8.66666 4.66536V11.6893ZM7.33332 11.6893V4.66536C7.33332 4.13493 7.12261 3.62622 6.74754 3.25115C6.37246 2.87608 5.86376 2.66536 5.33332 2.66536H1.99999V11.332H5.99999C6.47214 11.332 6.93139 11.4572 7.33332 11.6893Z",
  fill: "#E5E7EB"
});
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.f03265ff815e4718c6205a9101b4d8d5.svg";
export { ForwardRef as ReactComponent };